import { Card } from "./ui/card";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "./ui/hover-card";

export const KeyBenefits = () => {
  const benefits = [
    {
      icon: "💡",
      title: "Smarter Response",
      description: "Step-by-step AI guidance replicating top medical professionals' decisions under pressure.",
      hoverTitle: "AI-Powered Decision Support",
      hoverDescription: "Our machine learning models are trained on thousands of successful resuscitations, capturing the decision patterns of expert code leaders to guide less experienced teams.",
    },
    {
      icon: "⚡",
      title: "Faster Outcomes",
      description: "Reduces delays in defibrillation, medication dosing, and airway management during Code Blue events.",
      hoverTitle: "Time-Critical Interventions",
      hoverDescription: "Every minute without intervention decreases survival by 7-10%. datasyteAI™ eliminates hesitation with clear, timely prompts for each critical action.",
    },
    {
      icon: "🔒",
      title: "Quantum Security",
      description: "Preparing for Q-Day with a roadmap toward quantum-resistant cryptography.",
      hoverTitle: "Future-Proof Security",
      hoverDescription: "As quantum computing advances, traditional encryption becomes vulnerable. We're implementing post-quantum cryptographic standards to protect patient data for decades to come.",
    },
  ];

  return (
    <section className="py-16" id="key-benefits">
      <div className="container mx-auto px-6">
        <div className="eyebrow eyebrow-dot mb-4 reveal">Why it matters</div>
        <h2 className="section-title mb-3 reveal">Key Benefits</h2>
        <p className="text-muted-foreground mb-8 reveal">
          From faster decisions to stronger safeguards—why AiMediQ™ powered by datasyteAI™ stands apart.
        </p>
        <div className="grid md:grid-cols-3 gap-7">
          {benefits.map((benefit, index) => (
            <HoverCard key={index} openDelay={200} closeDelay={100}>
              <HoverCardTrigger asChild>
                <Card className="reveal p-6 hover:-translate-y-2 transition-transform duration-300 bg-secondary/50 cursor-pointer">
                  <div className="text-4xl mb-3">{benefit.icon}</div>
                  <h3 className="text-xl font-bold mb-2">{benefit.title}</h3>
                  <p className="text-muted-foreground">{benefit.description}</p>
                </Card>
              </HoverCardTrigger>
              <HoverCardContent className="w-80 bg-card/95 backdrop-blur-sm border-primary/20">
                <div className="space-y-2">
                  <h4 className="text-sm font-semibold text-primary">{benefit.hoverTitle}</h4>
                  <p className="text-sm text-muted-foreground">{benefit.hoverDescription}</p>
                </div>
              </HoverCardContent>
            </HoverCard>
          ))}
        </div>
      </div>
    </section>
  );
};
